import { render, staticRenderFns } from "./StudentMealReport.vue?vue&type=template&id=6683ef55&scoped=true"
import script from "./StudentMealReport.vue?vue&type=script&lang=js"
export * from "./StudentMealReport.vue?vue&type=script&lang=js"
import style0 from "./StudentMealReport.vue?vue&type=style&index=0&id=6683ef55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6683ef55",
  null
  
)

export default component.exports